const mutations = {
  SAVE_DATA(state, data) {
    localStorage.setItem('home', JSON.stringify(data));
    state.home = data;
  },
  SAVE_APPLICATION_ID(state, data) {
    state.applicationId = data;
  },
};
export default mutations;
